'use client';

import NumLib from 'src/utils/NumLib';
import useCollateralPrice from './useCollateralPrice';

const useDisplayPrecisionForCollateral = (spotMarketIndex: number) => {
	const currentCollateralPrice = useCollateralPrice(spotMarketIndex);

	const collateralDisplayPrecision = NumLib.getDisplayPrecision(
		currentCollateralPrice
	);

	return collateralDisplayPrecision;
};

export default useDisplayPrecisionForCollateral;
